import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import MDBox from 'components/MDBox';
import Typography from '@mui/material/Typography';
import {
  CalendarEventButtonGrid,
  EventDetailsGrid,
} from 'components/Ui/styled';
import { FormInputText } from 'components/Common/Forms/FormInputText';
import { FormInputDate } from 'components/Common/Forms/FormInputDate';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';
import FormInputDropdown from 'components/Common/Forms/FormInputDropdown';
import moment from 'moment/moment';

const EventDialog = () => {
  const calendarCategories = useSelector(
    (state) => state.dashboard?.calendarCategories
  );

  const categories = calendarCategories?.map((item) => ({
    id: item.categoryId,
    value: item.name,
  }));

  const currentDate = new Date();

  const calendarEvent = useSelector((state) => state.calendarEvent);
  let {
    title,
    description,
    startDate,
    endDate,
    startTime,
    endTime,
    location,
    isAllDayEvent,
    categoryId,
    eventId,
  } = calendarEvent;

  const timezoneOffset = new Date().getTimezoneOffset() > 0 ? 2 : 1;

  if (timezoneOffset !== 1) {
    const addOneDay = (date) =>
      date ? moment(date).add(1, 'day').format('YYYY-MM-DD') : '';

    startDate = addOneDay(startDate);
    endDate = addOneDay(endDate);
  }

  const defaultValue = useMemo(
    () => ({
      title: title,
      description: description,
      start: startDate,
      end: endDate,
      startTime: startTime,
      endTime: endTime,
      location: location,
      allDay: isAllDayEvent,
      category: categoryId,
      eventId: eventId,
    }),
    [
      title,
      description,
      startDate,
      endDate,
      startTime,
      endTime,
      location,
      isAllDayEvent,
      categoryId,
      eventId,
    ]
  );

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });
  const { reset, control } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue, reset]);

  const renderEventForm = () => {
    return (
      <>
        <CalendarEventButtonGrid container>
          <Typography variant="h6">Event Details</Typography>
        </CalendarEventButtonGrid>
        <FormInputText
          name="title"
          type="text"
          control={control}
          label="Title"
        />
        <FormInputText
          name="description"
          type="text"
          control={control}
          label="Description"
        />
        <FormInputDate
          name="start"
          control={control}
          label="Start date"
          minDate={currentDate}
          value={startDate}
        />
        <FormInputDate
          name="end"
          control={control}
          label="End date"
          minDate={currentDate}
          value={endDate}
        />
        <FormInputSwitch
          control={control}
          name="allDay"
          label="All Day"
          checked={defaultValue.allDay}
        />
        {!defaultValue.allDay && (
          <>
            <FormInputText
              name="startTime"
              type="time"
              shrink={true}
              control={control}
              label="Start time"
            />
            <MDBox pb={2}></MDBox>
            <FormInputText
              name="endTime"
              type="time"
              shrink={true}
              control={control}
              label="End time"
            />
          </>
        )}
        <FormInputText
          name="location"
          type="text"
          control={control}
          label="Location"
        />
        <FormInputDropdown
          name="category"
          type="text"
          control={control}
          options={categories}
          label="Categories"
        />
      </>
    );
  };

  return (
    <>
      <EventDetailsGrid container>{renderEventForm()}</EventDetailsGrid>
    </>
  );
};

export default EventDialog;
